import AddIcon from "@mui/icons-material/Add";
import ReplayIcon from "@mui/icons-material/Replay";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import { Box, styled, TextField, Typography } from "@mui/material";
import { DeleteIconList, UploadThumbnail } from "@platformx/shared/static-assets";
import { buildCDNURL, getRandomNumberAddon, ShowToastError } from "@platformx/utilities";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const Options = ({
  showGallery,
  items,
  setItems,
  changeCrop,
  variant,
  validations,
  placeholder,
}) => {
  const { t } = useTranslation();
  const [, setOperationType] = useState<string>("replace");
  const [, setAnswers1] = useState<any>(items);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isDeleteDisable, setIsDeleteDisable] = useState(false);

  const handleChange = (event) => {
    if (event.target.value.length > 100) {
      ShowToastError(`${t("max_char")} 100!`);
    }
    setItems(
      items.map((item) =>
        item.id === event.target.name ? { ...item, option: event.target.value } : item,
      ) as [],
    );
  };
  const onUploadClick = (type, id) => {
    showGallery(id);
    setOperationType(type);
  };
  const onAddOption = () => {
    if (items?.length < 20) {
      setItems([
        ...items,
        {
          id: `${getRandomNumberAddon(items, 1, 200)}`,
          option: "",
          image: "",
          status: false,
        },
      ]);
    } else {
      ShowToastError(t("options_20limit_toast"));
    }
  };
  useEffect(() => {
    setAnswers1(items);
  }, [items]);
  // useEffect(() => {
  //   if (items.length <= 2) {
  //     setIsDeleteDisable(true);
  //   } else {
  //     setIsDeleteDisable(false);
  //   }
  // }, [items]);
  const onDeleteOption = (id) => {
    // if (items.length > 2) {
    setItems(items.filter((item) => item.id !== id));
    // }
  };

  const RoundBox = styled("div")({
    position: "absolute",
    right: "20px",
    top: "20px",
    width: "40px",
    height: "40px",
    background: "#fff",
    zIndex: "9",
    borderRadius: "4px",
    boxShadow: "0 10px 25px 0 rgba(0, 0, 0, 0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  });
  // Extract pattern and message from validations array if present
  const patternValidation = validations?.find((v) => v.type === "pattern");
  const pattern = patternValidation?.value ? new RegExp(patternValidation.value) : "";
  const patternMessage = patternValidation?.message || "";
  return (
    <>
      {items.map((item) => {
        return (
          // eslint-disable-next-line react/jsx-key
          <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", marginBottom: "10px" }}>
            <Box sx={{ display: "flex", gap: "10px" }}>
              {item?.image?.published_images ? (
                <Box
                  sx={{
                    width: "100%",
                    height: "192px",
                    // border: "solid 1px #ced3d9",
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}>
                  <img
                    alt='answer_image1'
                    style={{
                      width: "inherit",
                      height: "inherit",
                      objectFit: "contain",
                      borderRadius: "inherit",
                      cursor: "pointer",
                    }}
                    src={buildCDNURL(
                      item?.image?.original_image.original_image_relative_path,
                      item?.image?.original_image.ext,
                    )}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: "0",
                      width: "inherit",
                      height: "inherit",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "rgba(0, 0, 0, 0.3)",
                      borderRadius: "inherit",
                    }}>
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={{ cursor: "pointer" }}
                        onClick={() => onUploadClick("Images", item.id)}>
                        <Box
                          sx={{
                            borderRadius: "50%",
                            width: "25px",
                            height: "25px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                          }}>
                          <ReplayIcon sx={{ color: "#fff" }} />
                        </Box>
                      </Box>
                      {variant !== "no_crop" && (
                        <RoundBox onClick={() => changeCrop(item.id)}>
                          <ViewQuiltIcon
                            sx={{
                              cursor: "pointer",
                              fontSize: { md: "22px" },
                            }}
                          />
                        </RoundBox>
                      )}
                    </Box>
                  </Box>
                </Box>
              ) : (
                <Box
                  onClick={() => onUploadClick("Images", item.id)}
                  sx={{
                    width: "100%",
                    height: "192px",
                    border: "solid 1px #ced3d9",
                    borderRadius: "5px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    gap: "10px",
                    cursor: "pointer",
                    backgroundColor: "#EFF0F6",
                  }}>
                  <img src={UploadThumbnail} alt='Icon' />
                  <Typography variant='h5medium' color='textColorPrimary' data-testid='chooseimage'>
                    {t("choose_your_image")}
                  </Typography>
                </Box>
              )}
              <Box
                sx={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                onClick={() => onDeleteOption(item.id)}>
                <img
                  src={DeleteIconList}
                  style={{
                    objectFit: "cover",
                    opacity: isDeleteDisable ? "0.4" : "1",
                  }}
                  alt='Delete Icon'
                />
              </Box>
            </Box>
            <Box>
              <Box>
                <TextField
                  error={
                    item.option?.length > 100 ||
                    (item.option && pattern && !pattern.test(item.option))
                  }
                  variant='filled'
                  size='small'
                  name={item.id}
                  className='titlefield '
                  placeholder={placeholder || ""}
                  value={item?.option}
                  inputProps={{ maxLength: 100 }}
                  sx={{
                    width: "94%",
                  }}
                  onChange={(e) => handleChange(e)}
                  helperText={
                    item.option && pattern && !pattern.test(item.option)
                      ? patternMessage
                      : item.option?.length > 100
                        ? `${t("max_char")} 100!`
                        : ""
                  }
                />
              </Box>
            </Box>
          </Box>
        );
      })}

      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer",
          margin: { sm: "10px 10px 10px 0px", xs: "10px 10px 10px -4px" },
          "&:hover": {
            color: "#4B9EF9",
          },
        }}
        onClick={onAddOption}>
        <AddIcon />
        <Typography
          variant='h7regular'
          sx={{
            color: "#2d2d39",
            pl: "8px",
            textTransform: "capitalize",
            "&:hover": {
              color: "#4B9EF9",
            },
          }}>
          Add
        </Typography>
      </Box>
    </>
  );
};
